import React, { Component, PropTypes } from 'react';

let didZedoScriptLoad = false;
const DATA_LAYER = {
	z_cltr: '%%CLICK_URL_UNESC%%',
	z_imtr: '%%VIEW_URL_UNESC%%'
};

class Zedo extends Component {
	static propTypes = {
		divId: PropTypes.string,
		clientId: PropTypes.string,
		async: PropTypes.bool
	}

	static defaultProps = {
		async: false
	}

	componentDidMount() {
		const { divId, clientId, async } = this.props;
		const divTag = document.getElementById(divId);
		const scriptTag = document.createElement('script');
		scriptTag.type = 'text/javascript';
		if (async){
			scriptTag.src = `https://3635.tm.zedo.com/v1/${clientId}/atm.js`;
			scriptTag.async = true;
			divTag.parentNode.appendChild(scriptTag, divTag);
			scriptTag.onload = scriptTag.onreadystatechange = () => {
				const newZedoTag = new zTagManager(divId);
				newZedoTag.initTagManager(divId, DATA_LAYER, this.async, 1, 1);
			};

		} else {
			scriptTag.src = `https://3635.tm.zedo.com/v1/${clientId}/tm.js?data=datalayer`;
			divTag.parentNode.appendChild(scriptTag, divTag);
		}
	}

	render() {
		const { divId } = this.props;

		return (
			<div id={divId} />
		);
	}
}

export default Zedo;



// WEBPACK FOOTER //
// ./app/components/ads/Zedo.js